import { Suspense, useEffect, useState } from "react";
import { IMaintenanceHistoryItem } from "../../../../types/maintenance.type"; // Supondo que você crie este tipo
import Loading from "../../../../common/components/ui/loading/Loading";
import GenericTable from "../../../../common/components/ui/table/GenericTable";
import TableFooter from "../../../../common/components/ui/table/TableFooter";
import {
  formatDate,
  formatDateAndTime,
} from "../../../../common/helpers/date.helpers"; // Usando formatDate se não precisar da hora
import { getMaintenanceHistory } from "@/common/services/maintenance.api";

const headers = {
  partReplaced: "Peça Trocada",
  quantity: "Quantidade",
  lastReplacementDate: "Data Última Troca",
  kmAtLastReplacement: "KM Última Troca",
};

interface MaintenanceHistoryTableProps {
  licensePlate: string;
}

function MaintenanceHistoryTable({
  licensePlate,
}: MaintenanceHistoryTableProps) {
  const [history, setHistory] = useState<IMaintenanceHistoryItem[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState<number>(1);
  const [paginationData, setPaginationData] = useState({
    itemsPerPage: 10,
    totalItems: 0,
  });

  useEffect(() => {
    async function loadHistory() {
      if (!licensePlate) return;

      setIsLoading(true);
      const result = await getMaintenanceHistory(licensePlate);

      if (result.ok) {
        setHistory(result.data as IMaintenanceHistoryItem[]);
        setPaginationData({
          itemsPerPage: 10,
          totalItems: result.totalItems,
        });
      } else {
        console.error("Falha ao buscar histórico de manutenção.");
        setHistory([]);
      }
      setIsLoading(false);
    }

    loadHistory();
  }, [licensePlate, page]);
  const maintenanceInfo = history.length > 0 ? history[0] : null;
  return (
    <Suspense fallback={<Loading />}>
      <div className="p-4">
        {maintenanceInfo ? (
          <div className="mb-4">
            <p className="text-base text-gray-600">
              <strong>Data:</strong>{" "}
              {formatDateAndTime(maintenanceInfo.maintenanceDate)} |
              <strong>Hodômetro:</strong>{" "}
              {maintenanceInfo.kmAtReplacement.toLocaleString("pt-BR")}
            </p>
          </div>
        ) : (
          <h2 className="text-xl font-semibold mb-4">
            Histórico de Manutenção - Placa: {licensePlate}
          </h2>
        )}
        <GenericTable
          headers={headers}
          data={history}
          actions={[]}
          renders={{
            lastReplacementDate: (date) => (date ? formatDate(date) : "-"),
            kmAtLastReplacement: (km) =>
              km ? (km as number).toLocaleString("pt-BR") : "-",
          }}
          entity="maintenanceHistory"
        />
        {isLoading && <Loading />}
        {!isLoading && history.length === 0 && (
          <div className="text-center py-8 text-gray-500">
            Nenhum histórico de peças encontrado para a última manutenção
            finalizada.
          </div>
        )}
        <TableFooter
          page={page}
          totalItems={paginationData.totalItems}
          itemsPerPage={paginationData.itemsPerPage}
          goToPage={setPage}
        />
      </div>
    </Suspense>
  );
}

export default MaintenanceHistoryTable;
